export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": "https://business-training.by/razvitie-personala#service",
        "name": "Развитие персонала",
        "description": "Развитие персонала: обучение сотрудников, развитие компетенций, оценка, наставничество, кадровый резерв и индивидуальные программы. Корпоративное обучение в Минске, Беларуси и онлайн.",
        "provider": {
          "@type": "Person",
          "name": "Алексей Сивко",
          "jobTitle": "Бизнес-тренер, консультант по продажам и управлению, фасилитатор, сертифицированный коуч ICU",
          "url": "https://business-training.by/o-trenere",
          "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
        },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "развитие персонала, обучение сотрудников, развитие компетенций",
        "url": "https://business-training.by/razvitie-personala"
      },
      {
        "@type": "WebPage",
        "name": "Развитие персонала: как системно развивать сотрудников и компетенции команды",
        "description": "Развитие персонала: обучение сотрудников, развитие компетенций, оценка, наставничество, кадровый резерв и индивидуальные программы. Корпоративное обучение в Минске, Беларуси и онлайн.",
        "url": "https://business-training.by/razvitie-personala",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что такое развитие персонала?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Развитие персонала — это система, которая помогает сотрудникам становиться сильнее в своей роли: приобретать необходимые компетенции, применять их в работе и постепенно брать на себя больше ответственности. Оно объединяет диагностику, обучение, практику, наставничество, обратную связь, оценку прогресса и подготовку кадрового резерва."
            }
          },
          {
            "@type": "Question",
            "name": "Чем развитие персонала отличается от обучения?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Обучение — это получение знаний и навыков, а развитие — их применение в работе. Обучение является частью развития, но само по себе не гарантирует изменения в поведении сотрудника. Развитие включает практику, обратную связь, наставничество, развивающие задачи и оценку прогресса."
            }
          },
          {
            "@type": "Question",
            "name": "Зачем компании развивать сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Системное развитие персонала помогает повысить самостоятельность сотрудников, улучшить качество работы, снизить зависимость от отдельных сильных специалистов, сформировать кадровый резерв и связать обучение с задачами бизнеса. Без системного подхода опыт не передаётся внутри команды, а после разовых тренингов сотрудники возвращаются к прежним привычкам."
            }
          },
          {
            "@type": "Question",
            "name": "Какие направления развития персонала существуют?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Основные направления: обучение сотрудников, развитие soft skills, адаптация новых сотрудников, наставничество, оценка эффективности обучения, разработка программ обучения, корпоративная академия, тренинг для руководителей и развитие управленческих компетенций. Компания может выбрать отдельное направление или комплексную программу."
            }
          },
          {
            "@type": "Question",
            "name": "Как определить, какие компетенции необходимо развивать?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Развитие начинается с определения бизнес-задач: какие результаты необходимо улучшить. Затем определяется, какие компетенции сотрудников влияют на эти результаты, проводится диагностика текущего уровня и выявляются дефициты. На основе этого формируется программа развития, связанная с реальными задачами компании."
            }
          },
          {
            "@type": "Question",
            "name": "Как оценить уровень сотрудников перед обучением?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Перед обучением проводится диагностика: интервью, анализ рабочих ситуаций, наблюдение, сбор обратной связи от руководителей. Цель — понять, что сотрудники уже умеют, где находятся дефициты и какие навыки влияют на бизнес-результаты. Это позволяет не проводить обучение ради обучения, а нацелить его на реальные потребности."
            }
          },
          {
            "@type": "Question",
            "name": "Как составить план развития сотрудника?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Хороший план развития отвечает на вопросы: какую компетенцию развиваем и зачем она нужна, какой текущий уровень и какой необходимо получить, какие действия выполняет сотрудник, кто помогает, как измеряется прогресс и когда проводится повторная оценка. План превращает абстрактное развитие в конкретные шаги."
            }
          },
          {
            "@type": "Question",
            "name": "Что такое индивидуальный план развития?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Индивидуальный план развития (ИПР) — это документ, который фиксирует конкретную компетенцию, цель развития, текущий и целевой уровни, действия сотрудника, ответственных и критерии измерения прогресса. Он нужен не каждому сотруднику, а в ситуациях, когда требуется точечное развитие конкретных навыков."
            }
          },
          {
            "@type": "Question",
            "name": "Как развивать сотрудников внутри компании?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Развитие внутри компании опирается на несколько инструментов: обучение, развивающие задачи, наставничество, участие в проектах, расширение ответственности, регулярная обратная связь и оценка прогресса. Важно, чтобы новые навыки применялись в реальной работе, а не оставались на уровне полученных знаний."
            }
          },
          {
            "@type": "Question",
            "name": "Как наставничество помогает развитию персонала?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Наставничество позволяет развивать сотрудников непосредственно в рабочем процессе: передавать опыт, помогать осваивать новые задачи, разбирать ошибки и давать обратную связь. Оно повышает самостоятельность сотрудников и готовит их к новым ролям быстрее, чем изолированное обучение."
            }
          },
          {
            "@type": "Question",
            "name": "Как формировать кадровый резерв?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Кадровый резерв — это не просто список перспективных сотрудников, а условия для их развития. Для подготовки будущих руководителей используются развивающие задачи, наставничество, участие в проектах, расширение ответственности, обучение управленческим компетенциям, обратная связь и оценка готовности к новой роли."
            }
          },
          {
            "@type": "Question",
            "name": "Как оценить эффективность развития сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Эффективность оценивается через повторную диагностику: изменились ли компетенции, применяются ли новые навыки в работе, как изменилось поведение сотрудников и повлияло ли это на бизнес-показатели. Оценка через 1-3 месяца после обучения показывает, закрепились ли изменения или остались только на уровне знаний."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли разработать индивидуальную программу развития для компании?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да. Индивидуальная программа разрабатывается под конкретную категорию сотрудников или задачу компании. Сначала проводится диагностика и определяются дефициты, затем формируется цель, подбирается обучение, практика и обратная связь, а в завершение проводится повторная оценка."
            }
          },
          {
            "@type": "Question",
            "name": "Сколько времени занимает программа развития персонала?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Продолжительность зависит от задач и формата. Корпоративный тренинг занимает 1-3 дня, модульная программа — несколько этапов с практикой между встречами, комплексная программа развития может длиться несколько месяцев. Точная продолжительность определяется после диагностики потребностей компании."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}